module.exports = __webpack_public_path__ + "static/media/League_of_Legends_Logo.13263953.png";